module.exports = __webpack_public_path__ + "static/media/down-chevron.61cf0702.svg";